<template>
  <div>
    <el-menu-item v-if="hasOneShowingChild(item)" :index="String(item.id)">
      <span>{{item.name}}</span>
      <el-badge v-if="item.name === '送货单'" :value="new_delivery_count" style="margin:0 0 5px 5px"></el-badge>
    </el-menu-item>

    <el-submenu v-else ref="subMenu" :index="String(item.id)">
      <template slot="title">
        <span>{{item.name}}</span>
      </template>
      <side-menu-item v-for="child in item.children" :key="child.id" :item="child"/>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SideMenuItem',
  props: {
    // route object
    item: {
      type: Object,
      required: true
    }
  },
  data: function () {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      new_delivery_count:sessionStorage.getItem('new_delivery_count')
    }
  },
  mounted: function () {
    window.addEventListener('setItem', ()=> {
      this.new_delivery_count = sessionStorage.getItem('new_delivery_count') === '0' ? '' : sessionStorage.getItem('new_delivery_count')
    })
  },
  methods: {
    hasOneShowingChild: function (_item) {
      return _item.children.length === 0
    }
  }
}
</script>
